export default {
  profile: 'Profile',
  logout: 'Logout',
  selectProfiles: 'Profile selection'
}
